import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'atn-add-button',
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss']
})
export class AddButtonComponent implements OnInit {
  @Input() url: string;

  constructor() {}
  ngOnInit() {}
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/add-button/add-button.component.ts